<template>
  <div>
    <p v-if="loading">
      <b-spinner variant="success" label="Loading"></b-spinner>
      <span>Loading scenarios...</span>
    </p>
    <p v-if="!loading && !scenarios.length">No scenarios found</p>
    <b-form-group v-if="!loading && !!scenarios.length">
      <template v-slot:label>
        <b>Select scenarios to remove:</b><br>
        <b-form-checkbox
          v-model="allSelected"
          :indeterminate="indeterminate"
          aria-describedby="scenarios"
          aria-controls="scenarios"
          @change="toggleAll"
        >
          {{ allSelected ? 'Un-select All' : 'Select All' }}
        </b-form-checkbox>
      </template>

      <div style=" max-height: 500px; overflow-y: visible; overflow-x: hidden;">
        <b-form-checkbox-group
          id="scenarios"
          v-model="selected"
          :options="options"
          name="scenarios"
          class="ml-4"
          aria-label="Scenarios to remove"
          stacked
        />
      </div>
    </b-form-group>

    <b-row>
      <b-col class="text-right">
        <b-button @click="cancel">Cancel</b-button>
        <b-button
          variant="primary"
          :disabled="!selected.length"
          @click="remove"
        >
          Ok
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    scenarios: {
      type:    Array,
      default: () => []
    },
    loading:   {
      type:    Boolean,
      default: false
    }
  },
  data() {
    return {
      selected:      [],
      allSelected:   false,
      indeterminate: false
    }
  },
  computed: {
    options() {
      return (this.scenarios || [])
        .map(({
                Id:           value,
                ScenarioName: name,
                DealName:     dealName,
                Vendor:       vendor
              }) => {
          const vendorAndDeal     = [vendor, dealName].filter(Boolean);
          const vendorAndDealText = vendorAndDeal.length ? ` (${vendorAndDeal.join(', ')})` : '';
          const text              = `${name}${vendorAndDealText}`
          return {value, text};
        });
    }
  },
  methods:  {
    toggleAll(checked) {
      this.selected = checked ? this.options.map(({value}) => value) : [];
    },
    remove() {
      this.$emit('remove', this.selected);
    },
    cancel() {
      this.$emit('cancel');
    }
  },
  watch:    {
    selected(newVal, oldVal) {
      if (newVal.length === 0) {
        this.indeterminate = false;
        this.allSelected   = false;
      } else if (newVal.length === this.options.length) {
        this.indeterminate = false;
        this.allSelected   = true;
      } else {
        this.indeterminate = true;
        this.allSelected   = false;
      }
    }
  }
}
</script>
